// Simple demo auth for the barbershop admin panel.
// Credentials are hardcoded for the prototype — replace with a real backend later.
const AUTH_KEY = 'barberco:admin-auth'
export const DEMO_USER = 'admin'
export const DEMO_PASS = 'admin123'

export function login(user: string, pass: string): boolean {
  if (user === DEMO_USER && pass === DEMO_PASS) {
    try {
      sessionStorage.setItem(AUTH_KEY, '1')
    } catch {
      /* ignore */
    }
    return true
  }
  return false
}

export function logout() {
  try {
    sessionStorage.removeItem(AUTH_KEY)
  } catch {
    /* ignore */
  }
}

export function isAuthenticated(): boolean {
  try {
    return sessionStorage.getItem(AUTH_KEY) === '1'
  } catch {
    return false
  }
}
